module.exports = __webpack_public_path__ + "static/media/logo.693fe195.png";